import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as Actions from 'actions';
import {
	validateEmail
} from 'api'; //from 'api/api'
import {Popover, OverlayTrigger} from 'react-bootstrap';


class UserNode extends React.Component {
    constructor(props) {
    super(props);
        this.state = {
            open : false,
        }

        this.displayName = 'UserNode';
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragStart = this.handleDragStart.bind(this);
        this.handleShowEdit = this.handleShowEdit.bind(this);
        this.handleClickUser = this.handleClickUser.bind(this);
    }

    handleDragStart(event) {
        event.dataTransfer.setData('text/plain',JSON.stringify(this.props.user));
    }

    handleDragEnd(event) {

    }

    handleDrop(event) {

        var user;
        try {
            user = JSON.parse(event.dataTransfer.getData('text/plain'));
        }
        catch(e) {
            return;
        }

        if(user && this.props.user && this.props.user._id != user._id) {
            this.props.setUserParent({
            	user_id : user._id,
            	parent_id: this.props.user._id
            });
        }
    }

    handleDragOver(event) {
        event.preventDefault();
    }

    handleShowEdit(event) {
    	event.stopPropagation();
      this.props.beginEditUserSaga(this.props.user._id);
    }

    handleClickUser() {
    	this.props.showViewUser(this.props.user);
    }

    render() {
        var {
            user
        } = this.props;

        const disabledUserPopover = (
				  <Popover id="popover-trigger-hover-focus" title="Account Disabled">
				    <strong>User disabled</strong> Contact admin if this is unexpected.
				  </Popover>
				);

        if(user) {
        		if(user.enabled === false) {
        			return (
        				<OverlayTrigger
	        				trigger={['hover', 'focus']}
	        				placement="bottom"
	        				overlay={disabledUserPopover}>
	        				<div className='disabled-user'>
			          		<div className={"user-node" + ((this.props.className)? " " + this.props.className : "")}>
				            	<div
				            		draggable={true}
				            		onDragStart={this.handleDragStart}
				            		onDrop={this.handleDrop}
				            		onDragEnd={this.handleDragEnd}
				            		onDragOver={this.handleDragOver}
				            		onClick={this.handleClickUser}
				            		className="btn btn-primary">
				            		{(() => {
				            			if(user && user.avatar)
				            				return (
				            					<div className="avatar">
								            		<img
								            			src={user.avatar}
								            			style={{width : "50px"}}
								            			className="img-responsive left" />
							                </div>
				            				)
				            		})()}
				                <div className="details">
				                  <h2 className="name">{user.name.first} {user.name.last}</h2>
				                  <p>{user.role}</p>
				                </div>
				                {(() => {
				                	if(this.props.hasPermission('/Account Management/Users/Edit/User Details/'))
				                		return (
				                			<div className="settings">
							                  <p
							                  	id='user-tree-user-node-edit-btn'
							                  	onClick={this.handleShowEdit}>
							                  	<i className="fa fa-edit"></i>
							                  </p>
							                </div>
				                		)
				                })()}
				            	</div>
				            </div>
			            </div>
		            </OverlayTrigger>
	            );
        		}
        		else {
	            return (
	          		<div className={"user-node" + ((this.props.className)? " " + this.props.className : "")}>
		            	<div
		            		draggable={true}
		            		onDragStart={this.handleDragStart}
		            		onDrop={this.handleDrop}
		            		onDragEnd={this.handleDragEnd}
		            		onDragOver={this.handleDragOver}
		            		onClick={this.handleClickUser}
		            		className="btn btn-primary">
		            		{(() => {
		            			if(user && user.avatar)
		            				return (
		            					<div className="avatar">
						            		<img
						            			src={user.avatar}
						            			style={{width : "50px"}}
						            			className="img-responsive left" />
					                </div>
		            				)
		            		})()}
		                <div className="details">
		                  <h2 className="name">{user.name.first} {user.name.last}</h2>
		                  <p>{user.role}</p>
		                </div>
		                {(() => {
		                	if(this.props.hasPermission('/Account Management/Users/Edit/User Details/'))
		                		return (
		                			<div className="settings">
					                  <p
					                  	id='user-tree-user-node-edit-btn'
					                  	onClick={this.handleShowEdit}>
					                  	<i className="fa fa-edit"></i>
					                  </p>
					                </div>
		                		)
		                })()}
		            	</div>
		            </div>
	            );
	          }
          }
        else
	        return <div></div>;
    }
}

UserNode.propTypes = {
	user : PropTypes.object.isRequired
}

export default connect(({connection, users}) => ({connection, users}), Actions)(UserNode);



// WEBPACK FOOTER //
// ./src/browser/components/users/userNode.js